<rs-popup>
    <div class="rs-share-warning-popup">
      <div class="rs-share-warning-popup__title">{{ 'owners.share-error' | translate }}</div>
      <div class="rs-share-warning-popup__actions">
        <button tabindex="-1" mat-raised-button color="primary" class="app__button" [mat-dialog-close]="true">{{ 'buttons.close' | translate }}</button>
      </div>
    </div>
</rs-popup>
